import { mapGetters } from 'vuex';

export default {
  methods: {
    shouldShowSignature(signature) {
      if (!signature) return false;

      if (this.currentIdentity) {
        if (signature.userId === this.currentIdentity.user_id) {
          return signature.name === this.currentIdentity.name;
        } else {
          return (
            signature.signatureType === 'image' ||
            signature.signatureType === 'text'
          );
        }
      } else {
        return signature.userId === this.currentUser.id;
      }
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),

    // Every forms are signed including forms requiring wet signatures
    allSigned() {
      const allSigned = this.taxReturn.e_sign_forms.every(form => {
        if (form.wetSignaturesRequired) {
          return form.wetSignatures && form.wetSignatures.length > 0;
        } else {
          return form.signatures
            .filter(item => this.shouldShowSignature(item))
            .every(signature => signature.signatureData);
        }
      });

      return allSigned;
    },
  },
};
